<template>
  <div class="auth-container">
    <div class="auth-bg">
      <div class="auth-card animate-fade-in">
        <div class="auth-header">
          <div class="logo-icon">
            <i class="fas fa-graduation-cap"></i>
          </div>
          <h1>智慧迎新平台</h1>
          <p class="subtitle">连接你的校园生活</p>
        </div>

        <div class="auth-tabs">
          <button
            :class="['tab-btn', { active: activeTab === 'login' }]"
            @click="activeTab = 'login'"
          >
            <i class="fas fa-sign-in-alt"></i> 登录
          </button>
          <button
            :class="['tab-btn', { active: activeTab === 'register' }]"
            @click="activeTab = 'register'"
          >
            <i class="fas fa-user-plus"></i> 注册
          </button>
        </div>

        <transition name="fade" mode="out-in">
          <!-- 登录表单 -->
          <form v-if="activeTab === 'login'" @submit.prevent="handleLogin" class="auth-form">
            <div class="form-group">
              <i class="fas fa-user form-icon"></i>
              <input
                v-model="loginForm.usernameOrEmail"
                type="text"
                placeholder="用户名 / 邮箱"
                required
              >
            </div>
            <div class="form-group">
              <i class="fas fa-lock form-icon"></i>
              <input
                v-model="loginForm.password"
                type="password"
                placeholder="密码"
                required
              >
            </div>
            <button type="submit" class="btn-submit" :disabled="loading">
              <i v-if="loading" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-sign-in-alt"></i>
              {{ loading ? '登录中...' : '登录' }}
            </button>
          </form>

          <!-- 注册表单 -->
          <form v-else @submit.prevent="handleRegister" class="auth-form">
            <div class="form-group">
              <i class="fas fa-user form-icon"></i>
              <input
                v-model="registerForm.username"
                type="text"
                placeholder="用户名"
                required
              >
            </div>
            <div class="form-group">
              <i class="fas fa-envelope form-icon"></i>
              <input
                v-model="registerForm.email"
                type="email"
                placeholder="邮箱"
                required
              >
            </div>
            <div class="form-group">
              <i class="fas fa-lock form-icon"></i>
              <input
                v-model="registerForm.password"
                type="password"
                placeholder="密码"
                required
              >
            </div>
            <div class="form-group">
              <i class="fas fa-phone form-icon"></i>
              <input
                v-model="registerForm.phone"
                type="tel"
                placeholder="手机号（选填）"
              >
            </div>
            <button type="submit" class="btn-submit">
              <i class="fas fa-user-plus"></i> 注册
            </button>
          </form>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserLogin',
  data() {
    return {
      activeTab: 'login',
      loading: false,
      loginForm: {
        usernameOrEmail: '',
        password: ''
      },
      registerForm: {
        username: '',
        password: '',
        email: '',
        phone: ''
      }
    }
  },
  methods: {
    async handleLogin() {
      this.loading = true
      try {
        const res = await this.$axios.post('/api/user/login', this.loginForm)
        if (res.data.code === 200) {
          this.$message.success('登录成功')
          localStorage.setItem('token', res.data.token)
          localStorage.setItem('user', JSON.stringify(res.data.user))
          this.$router.push('/dashboard')
        } else {
          this.$message.error(res.data.message)
        }
      } catch (error) {
        this.$message.error('登录失败')
      } finally {
        this.loading = false
      }
    },
    async handleRegister() {
      try {
        const res = await this.$axios.post('/api/user/register', this.registerForm)
        if (res.data.code === 200) {
          this.$message.success('注册成功，请登录')
          this.activeTab = 'login'
          this.registerForm = { username: '', password: '', email: '', phone: '' }
        } else {
          this.$message.error(res.data.message)
        }
      } catch (error) {
        this.$message.error('注册失败')
      }
    }
  }
}
</script>

<style scoped>
.auth-container {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.auth-bg {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.auth-card {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 24px;
  padding: 40px;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
}

.animate-fade-in {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.auth-header {
  text-align: center;
  margin-bottom: 32px;
}

.logo-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}

.logo-icon i {
  font-size: 32px;
  color: white;
}

.auth-header h1 {
  font-size: 28px;
  color: #333;
  margin-bottom: 8px;
}

.subtitle {
  color: #888;
  font-size: 14px;
}

.auth-tabs {
  display: flex;
  gap: 12px;
  margin-bottom: 28px;
  background: #f5f5f5;
  padding: 4px;
  border-radius: 12px;
}

.tab-btn {
  flex: 1;
  padding: 10px;
  border: none;
  background: transparent;
  font-size: 16px;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.3s;
  color: #666;
}

.tab-btn i {
  margin-right: 6px;
}

.tab-btn.active {
  background: white;
  color: #667eea;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  position: relative;
}

.form-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 16px;
}

.form-group input {
  width: 100%;
  padding: 14px 14px 14px 42px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  font-size: 15px;
  transition: all 0.3s;
  box-sizing: border-box;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.btn-submit {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 8px;
}

.btn-submit i {
  margin-right: 8px;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(102, 126, 234, 0.4);
}

.btn-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>